import { render } from "./dashBoard.vue?vue&type=template&id=32d3999c"
import script from "./dashBoard.vue?vue&type=script&lang=js"
export * from "./dashBoard.vue?vue&type=script&lang=js"

import "./dashBoard.vue?vue&type=style&index=0&id=32d3999c&lang=scss"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__